import { render, staticRenderFns } from "./listaJogadores.vue?vue&type=template&id=dbd6abac&"
import script from "./listaJogadores.vue?vue&type=script&lang=js&"
export * from "./listaJogadores.vue?vue&type=script&lang=js&"
import style0 from "./listaJogadores.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports